import React from 'react';
import { Link } from 'react-router-dom';
import { PageHeading } from '../components/PageHeading';
import { business } from '../data/site';
import { smsProgram } from '../data/smsProgram';
import { usePageMeta } from '../hooks/usePageMeta';
const headingClass = 'font-display text-[22px] font-bold tracking-tight text-ink';
const linkClass = 'font-semibold text-brand-dark underline underline-offset-2 hover:text-ink';
export function PrivacyPolicy() {
  usePageMeta('Privacy Policy | East End Automotive Repair', 'How East End Automotive Repair, LLC handles contact information, service inquiries, and SMS consent.');
  return <>
      <PageHeading eyebrow="Your information" title="Privacy Policy" intro="How East End Automotive Repair handles information you share with the shop." showCall={false} data-id="element-603" data-mp="1984fojfu6qui" />
      <article className="mx-auto max-w-3xl space-y-9 px-5 py-12 text-[16px] leading-relaxed text-steel/85 sm:py-16 lg:px-8" data-id="element-604" data-mp="21scp36qk0sl0">
        <p className="text-[14px] text-steel/65" data-id="element-605" data-mp="51awewnyof90">
          Last updated: {smsProgram.updatedLabel}
        </p>

        <p data-id="element-606" data-mp="a0njniiqvoc4">
          East End Automotive Repair is operated by {smsProgram.legalName}.
        </p>

        <section aria-labelledby="privacy-information" data-id="element-607" data-mp="3rhdpwgmuvzfo">
          <h2 id="privacy-information" className={headingClass} data-id="element-608" data-mp="3rej34igde2j3">Information you provide</h2>
          <p className="mt-3" data-id="element-609" data-mp="87zqfnw0pol">
            When you contact {smsProgram.legalName}, you may provide your name,
            telephone number, email address, vehicle information, and details
            about your inquiry, appointment, or repair.
          </p>
          <p className="mt-3" data-id="element-610" data-mp="38it330rzzg7u">
            We use information you provide to answer your questions, arrange
            appointments, and communicate about your vehicle and repair work.
          </p>
        </section>

        <section aria-labelledby="privacy-sms" data-id="element-611" data-mp="16qwg8v0dqjxr">
          <h2 id="privacy-sms" className={headingClass} data-id="element-612" data-mp="1bp7q35qocufz">SMS choices and information</h2>
          <p className="mt-3" data-id="element-613" data-mp="1a8apvo6lsdb5">
            Our website forms are for inquiries and appointment or callback
            requests. Submitting a form does not enroll you in text messages
            or provide SMS consent. Separate consent is required for our
            customer-care text program, which covers inquiries, appointments,
            and repair updates. Consent is not a condition of purchase or service.
          </p>
          <p className="mt-3" data-id="element-614" data-mp="1sz1ukcfnbfj7">
            The program sender is {smsProgram.sender}. Message frequency varies
            with your inquiry, appointment, or repair. Message and data rates
            may apply. Reply STOP to opt out or HELP for help.
          </p>
          <p className="mt-3" data-id="element-615" data-mp="1f7dk0dl1oz4c">
            Mobile information, including telephone numbers and SMS consent,
            is not sold or shared with third parties or affiliates for
            marketing or promotional purposes. SMS consent is not transferred
            to other businesses.
          </p>
          <p className="mt-3" data-id="element-616" data-mp="3plb78v2txhf3">
            Service providers necessary to deliver our messages may process
            mobile information for that purpose only, without using it for
            their own marketing.
          </p>
          <p className="mt-3" data-id="element-617" data-mp="2gc21m7ady4e">
            Read the{' '}
            <Link to={smsProgram.termsPath} className={linkClass} data-id="element-618" data-mp="2iy97kq9mbm3">SMS Terms</Link>{' '}
            for program details and your messaging choices.
          </p>
        </section>

        <section aria-labelledby="privacy-choices" data-id="element-619" data-mp="cej6j5ke2npi">
          <h2 id="privacy-choices" className={headingClass} data-id="element-620" data-mp="hdcigtk126nk">Questions and choices</h2>
          <p className="mt-3" data-id="element-621" data-mp="m4uo3uwzwvev">
            You can contact the shop with questions about your information or
            to ask us to correct information you provided. You can ask us to
            stop texting at any time by replying STOP.
          </p>
          <p className="mt-3 font-semibold text-ink" data-id="element-622" data-mp="v73wae4skcp3">{smsProgram.legalName}</p>
          <p data-id="element-623" data-mp="1055ekwue87zi">
            {business.address.street}, {business.address.city},{' '}
            {business.address.state} {business.address.zip}
          </p>
          <p className="mt-2" data-id="element-624" data-mp="hik2vhqa4kwk">
            Shop support:{' '}
            <a href={business.phoneHref} className={linkClass} data-id="element-625" data-mp="hia8zj245tll">{business.phone}</a>
          </p>
          <p className="mt-2 break-words" data-id="element-626" data-mp="w6wuy3m8xjls">
            Email:{' '}
            <a href={`mailto:${business.email}`} className={linkClass} data-id="element-627" data-mp="r83mipltgish">{business.email}</a>
          </p>
        </section>

        <Link to={smsProgram.contactPath} className={linkClass} data-id="element-628" data-mp="3javn7k1x14q">
          Contact The East End Team
        </Link>
      </article>
    </>;
}